module.exports = __webpack_public_path__ + "img/process_01.f2ad6ad7.png";